export var greenTilleulVerveine = "green-tilleul-verveine";
export var greenBourgeon = "green-bourgeon";
export var greenEmeraude = "green-emeraude";
export var greenMenthe = "green-menthe";
export var greenArchipel = "green-archipel";
export var blueEcume = "blue-ecume";
export var blueCumulus = "blue-cumulus";
export var purpleGlycine = "purple-glycine";
export var pinkMacaron = "pink-macaron";
export var pinkTuile = "pink-tuile";
export var yellowTournesol = "yellow-tournesol";
export var yellowMoutarde = "yellow-moutarde";
export var orangeTerreBattue = "orange-terre-battue";
export var brownCafeCreme = "brown-cafe-creme";
export var brownCaramel = "brown-caramel";
export var brownOpera = "brown-opera";
export var beigeGrisGalet = "beige-gris-galet";
export var illustrativeColors = [
    greenTilleulVerveine,
    greenBourgeon,
    greenEmeraude,
    greenMenthe,
    greenArchipel,
    blueEcume,
    blueCumulus,
    purpleGlycine,
    pinkMacaron,
    pinkTuile,
    yellowTournesol,
    yellowMoutarde,
    orangeTerreBattue,
    brownCafeCreme,
    brownCaramel,
    brownOpera,
    beigeGrisGalet,
];
/**
 * @deprecated sera supprimé dans la Release2024.08
 */
export var listeCouleursIllustratives = illustrativeColors;
